<template>
	<div>
		<el-breadcrumb separator="/">
			<el-breadcrumb-item>缺陷筛选</el-breadcrumb-item>
			<el-breadcrumb-item>批次列表</el-breadcrumb-item>
		</el-breadcrumb>

		<div class="form-bar">
			<el-form :inline="true">
				<el-form-item>
					<DateRange v-model="dateRange" />
				</el-form-item>
				<el-form-item>
					<el-select v-model="jt_id" placeholder="请选择车间" :clearable="true">
						<el-option-group v-for="group in jtData" :key="group.value" :label="group.label">
							<el-option v-for="item in group.jtList" :key="item.value" :label="item.label" :value="item.value"></el-option>
						</el-option-group>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-select v-model="jobOrderId" placeholder="工单" :clearable="true">
						<el-option v-for="item in jobOrders" :key="item.value" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-input placeholder="请输入批次关键字" v-model="batchName" @keyup.enter.native="query"></el-input>
				</el-form-item>
				<el-form-item>
					<el-select v-model="batchFilterStatus" placeholder="请选择筛选状态" :clearable="true">
						<el-option v-for="item in filterStatus" :key="item.value" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" v-on:click="search">批次查询</el-button>
				</el-form-item>
				<el-form-item  style="float:right;">
				<!-- <div style="float:right;"> -->
					<el-button type="info" @click="uploadBatch">上传选中批次</el-button>
				<!-- </div> -->
				</el-form-item>
			</el-form>
		</div>

		<div>
			<el-table border :data="tableData" @selection-change="handleSelectionChange" v-loading="tableLoading" :default-sort="{ prop: 'roll_code', order: 'descending' }" @sort-change="sortChange">
				<el-table-column type="selection" width="60" :selectable="checkboxT"></el-table-column>
				<el-table-column type="index" width="60" label="序号"></el-table-column>
				<el-table-column prop="uploadFinished" label="上传状态" width="100" :formatter="formatter"></el-table-column>
				<el-table-column prop="roll_code" label="批次名称" min-width="120"></el-table-column>
				<el-table-column prop="product_name" label="产品名称" width="120"></el-table-column>
				<el-table-column prop="jt_name" label="机台" width="100"></el-table-column>
				<el-table-column prop="jobOrderCode" label="工单号" width="120" :show-overflow-tooltip="true"></el-table-column>
				<!-- <el-table-column prop="statusText" label="批次状态" width="120"></el-table-column> -->
				<el-table-column prop="filterStatusText" label="筛选状态" width="80"></el-table-column>
				<el-table-column prop="Insp_count" label="检测张数" width="110" sortable="custom"></el-table-column>
				<el-table-column prop="bad_count" label="坏品张数" width="120" sortable="custom"></el-table-column>
				<el-table-column prop="total_len" label="总长度" width="110" sortable="custom"></el-table-column>
				<el-table-column prop="total_def_count" label="缺陷个数" width="110" sortable="custom"></el-table-column>
				<el-table-column prop="bad_len_printer" label="印刷缺陷长度" width="130" sortable="custom"></el-table-column>
				<el-table-column prop="bad_len_qa" label="QA确认缺陷长度" width="155" sortable="custom"></el-table-column>
				<el-table-column prop="bad_Len_qa_judgement" label="QA调整缺陷长度" width="155" sortable></el-table-column>
				<el-table-column label="查看" width="200" fixed="right">
					<template slot-scope="scope">
						<el-button type="text" icon="el-icon-s-data" @click="handleBrowser(scope.row)">缺陷浏览</el-button>
						<el-divider direction="vertical"></el-divider>
						<el-button type="text" icon="el-icon-s-data" @click="handleViewReport(scope.row)">缺陷报表</el-button>
					</template>
				</el-table-column>
			</el-table>

			<!--分页-->
			<el-pagination layout="sizes, prev, pager, next, total" :page-count="pageCount" :current-page="pageIndex" :page-sizes="[10, 50, 100, 200]" :size="pageSize" @current-change="currentChange" @size-change="sizeChange"></el-pagination>
		</div>
	</div>
</template>

<script>
	import DateRange from '@/components/DateRangePicker'
	import defectService from '@/service/defectService'
	import dictionaryData from '@/service/dictionaryData'
	import { $in, like } from '@/network/util/QueryBuilder'
	import { axios } from '@/network/util/request'
	import { jobOrderRequest } from '@/network/requests/jobOrder'
	export default {
		components: {
			DateRange,
		},
		data() {
			return {
				dateRange: [],
				tableData: [],
				batchLIstId: [],
				batchIdList: [],
				idList: [],
				jtData: [],
				jt_id: '',
				tableLoading: false,
				pageSize: 10,
				pageIndex: 1,
				pageCount: 1,
				batchName: '',
				batchFilterStatus: 0,
				filterStatus: [
					{
						value: 0,
						label: '未筛选',
					},
					{
						value: 1,
						label: '正在筛选',
					},
					{
						value: 2,
						label: '筛选完成',
					},
				],
				/**
				 * 工单列表，用来填充下拉框。
				 */
				jobOrders: [],
				jobOrderId: '',
				sortQuery: {
					start_time: -1,
				},
			}
		},

		methods: {
			/**
			 * 复选框状态。
			 */
			checkboxT(row, index) {
				if (row.uploadFinished == null || row.uploadFinished == '') {
					if (row.filterStatusText == "筛选完成") 
					return true
				}
				return  false
			},
			formatter(row, column) {
				if (row.uploadFinished == true) {
					return <div style="color:green">上传完成</div>
				} else if (row.uploadFinished == false) {
					return <div style="color:red">上传中</div>
				}
				return '未上传'
			},
			/**
			 * 选择上传批次信息
			 */
			handleSelectionChange(val) {
				this.idList = val.map(t => t._id.$oid)
				console.log('this.idList', this.idList)
			},
			/**
			 * 选择批次上传
			 */
			uploadBatch() {
				console.log('批次列表id', this.idList)
				var self = this

				if (this.idList.length == 0 || this.idList == null) {
					this.$message({
						type: 'error',
						message: '请选择数据',
					})
					return false
				} else {
					this.tableLoading = true
					axios({ url: `/defect/upload`, method: 'post', data: { defectStatisIds: this.idList } })
						.then(res => {
							//self.query()
							setTimeout(() => {
								this.$message({
									message: '正在上传',
									type: 'success',
								})
								self.query()
							}, 2000)
						})
						.catch(err => {
							this.$message({
								message: '错误信息',
								type: 'error' + err.message,
							})
						})
				}
			},
			/**
			 * 获取查询条件。
			 */
			getFilter() {
				var filter = {}
				var count = 0
				if (this.dateRange !== null && this.dateRange.length > 1) {
					filter['begin_time'] = {
						$gte: { $date: new Date(this.dateRange[0]).getTime() },
						$lte: { $date: new Date(this.dateRange[1]).getTime() },
					}

					count++
				}

				if (this.jt_id) {
					filter['jt_id'] = this.jt_id
					count++
				}

				if (this.batchName) {
					filter['roll_code'] = like(this.batchName)
					count++
				}

				if (this.jobOrderId) {
					filter['job_order_id'] = this.jobOrderId
				}

				if (this.batchFilterStatus >=0 && this.batchFilterStatus !=='') {
					// if (this.batchFilterStatus) {					
						filter['filter_status'] = this.batchFilterStatus
						count++
					// }
				}

				if (count == 0) filter = undefined

				return filter
			},
			/**
			 * 搜索。
			 */
			search() {
				this.pageIndex = 1
				this.tableLoading = true
				this.query()
			},
			/**
			 * 查询所有批次。
			 */
			query() {
				var filter = this.getFilter()
				console.log(this.dateRange, 'filter', filter)
				defectService.getDefectStatList(this.pageIndex, this.pageSize, filter, this.sortQuery).then(res => {
					this.tableData = res.data
					console.log('resdata', res.data)
					this.pageCount = res.totalPage
					this.tableLoading = false
					this.idList = []
				})
			},

			/**
			 *
			 */
			currentChange(index) {
				this.tableLoading = true
				this.pageIndex = index
				this.query()
			},
			/**
			 *
			 */
			sizeChange(size) {
				this.tableLoading = true
				this.pageIndex = 1
				this.pageSize = size

				this.query()
			},
			/**
			 * 缺陷浏览。
			 */
			handleBrowser(row) {
				const routeData = this.$router.resolve({ name: 'Browser', query: { batch_id: row._id.$oid } })
				window.open(routeData.href, '_blank')
			},
			/**
			 * 查看报表。
			 */
			handleViewReport(row) {
				const routeData = this.$router.resolve({ name: 'defect_report', query: { defect_statis_id: row._id.$oid } })
				window.open(routeData.href, '_blank')
			},
			/**
			 * 获取工单下拉框数据。
			 */
			getJobOrderds() {
				jobOrderRequest.queryAll(undefined, { _id: 1, code: 1 }).then(res => {
					console.log('getJobOrderds', res)

					this.jobOrders = res.map(item => {
						return {
							value: item._id.$oid,
							label: item.code,
						}
					})
				})
			},
			/**
			 * 排序事件处理。
			 */
			sortChange({ column, prop, order }) {
				console.log('排序事件处理：', column, prop, order)

				this.sortQuery[prop] = order == 'ascending' ? 1 : -1
				this.query()
			},
		},
		async created() {
			this.tableLoading = true
			this.jtData = await dictionaryData.getJTListGroupByWorkshop()
			this.query()

			this.getJobOrderds()
		},
	}
</script>

<style></style>
